<div [ngClass]="_containerClass">
    <div [class]="clearable && (file || hasError) ? 'input-group' : ''">
        <label [ngClass]="_inputClass">
            <input
                (change)="onChange($event)"
                type="file"
                [accept]="accept"
                class="emma-input-file__input"
                [required]="!!required"
                [readonly]="readonly"
                [disabled]="disabled"
            />
            <ng-container [ngSwitch]="hasError">
                <ng-container *ngSwitchCase="true"> {{ fileErrorText }} </ng-container>
                <ng-container *ngSwitchDefault [ngSwitch]="loading">
                    <ng-container *ngSwitchCase="false">
                        <ng-container *ngIf="file"> {{ filename }} ({{ humanReadableSize }}) </ng-container>
                        <ng-container *ngIf="!file"> {{ placeholder }} </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault> {{ fileLoadingText }} </ng-container>
                </ng-container>
            </ng-container>
        </label>
        <ng-container *ngIf="clearable && (file || hasError)">
            <button (click)="onClear()" class="btn btn-metal m-btn--icon" type="button">
                <span class="m--font-danger">
                    <i class="la la-trash" aria-hidden="true"></i>
                    <span i18n>Eliminar</span>
                </span>
            </button>
        </ng-container>
    </div>
</div>
